import * as tslib_1 from "tslib";
import { Component } from 'vue-property-decorator';
import { User } from '@/models/User';
import { mapMutations, mapState } from 'vuex';
import MenuItem from "@/components/Base/MenuItem/MenuItem.vue";
import MenuItemGroup from '@/components/Base/MenuItem/MenuItemGroup/MenuItemGroup.vue';
import Globals from '@/classes/Globals';
import JSPage from '@/classes/JSPage';
import Assets from '@/classes/Assets';
let Sidebar = class Sidebar extends JSPage {
    constructor() {
        super(...arguments);
        this.menu = new Array();
        this.foundPage = true;
        this.Assets = Assets;
    }
    created() {
        super.created();
        Globals.watch(this, (globals) => this.foundPage = globals.isPageFound());
    }
    main() {
        this.menu = [];
        this.menu.push({
            icon: 'mdi-view-dashboard',
            title: 'Principal',
            roles: [User.TYPE_ADMINISTRATOR, User.TYPE_COMPANY, User.TYPE_USER],
            to: '/dashboard'
        });
        this.menu.push({
            icon: 'mdi-domain',
            title: 'Empresas',
            roles: [User.TYPE_ADMINISTRATOR],
            to: '/companies'
        });
        this.menu.push({
            icon: 'mdi-account-group',
            title: 'Técnicos',
            roles: [User.TYPE_ADMINISTRATOR, User.TYPE_COMPANY],
            to: '/users'
        });
        this.menu.push({
            icon: 'mdi-group',
            title: 'Grupos',
            roles: [User.TYPE_ADMINISTRATOR, User.TYPE_COMPANY, User.TYPE_USER],
            to: '/groups'
        });
        this.menu.push({
            icon: 'mdi-router-wireless',
            title: 'Dispositivos',
            roles: [User.TYPE_ADMINISTRATOR, User.TYPE_COMPANY, User.TYPE_USER],
            to: '/devices'
        });
        this.menu.push({
            icon: 'mdi-alert',
            title: 'Alertas',
            roles: [User.TYPE_ADMINISTRATOR, User.TYPE_COMPANY, User.TYPE_USER],
            to: '/alerts'
        });
        let systemMenu = new Array();
        systemMenu.push({
            icon: 'mdi-account-tie',
            title: 'Administradores',
            roles: [User.TYPE_ADMINISTRATOR],
            to: '/system/administrators'
        });
        systemMenu.push({
            icon: 'mdi-account-supervisor',
            title: ['Admins de Empresas', 'Administradores'],
            roles: [User.TYPE_ADMINISTRATOR, User.TYPE_COMPANY],
            to: '/system/companies/admins'
        });
        systemMenu.push({
            icon: 'mdi-shield-account',
            title: 'Roles',
            roles: [User.TYPE_ADMINISTRATOR, User.TYPE_COMPANY],
            to: '/system/roles'
        });
        systemMenu.push({
            icon: 'mdi-domain',
            title: 'Mi empresa',
            roles: [User.TYPE_USER, User.TYPE_COMPANY],
            to: '/system/company'
        });
        systemMenu.push({
            icon: 'mdi-cog',
            title: 'Configuración',
            roles: [User.TYPE_ADMINISTRATOR],
            to: '/configuration'
        });
        this.menu.push({
            avatar: 'mdi-cog',
            title: 'Sistema',
            group: 'configuration',
            children: systemMenu
        });
    }
};
Sidebar = tslib_1.__decorate([
    Component({
        components: {
            MenuItem,
            MenuItemGroup
        },
        computed: mapState([
            'barColor',
            'sidebarState',
            'excludedPages'
        ]),
        methods: mapMutations({
            setSidebarState: 'setSidebarState'
        })
    })
], Sidebar);
export default Sidebar;
